import { render, staticRenderFns } from "./MenuUserInfo.vue?vue&type=template&id=99e33ad6&scoped=true"
import script from "./MenuUserInfo.vue?vue&type=script&lang=ts"
export * from "./MenuUserInfo.vue?vue&type=script&lang=ts"
import style0 from "./MenuUserInfo.vue?vue&type=style&index=0&id=99e33ad6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e33ad6",
  null
  
)

export default component.exports